import { Outlet } from 'react-router-dom'

export function AuthLayout() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-md w-full space-y-8 p-8">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-900">
            IT Maturity Assessment
          </h1>
          <p className="mt-2 text-sm text-gray-600">
            Comprehensive evaluation of your organization's IT capabilities
          </p>
        </div>
        <Outlet />
      </div>
    </div>
  )
}
